import script from "./MobileApp.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileApp.vue?vue&type=script&setup=true&lang=js"

import "./MobileApp.vue?vue&type=style&index=0&id=c100ab2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c100ab2c"]])

export default __exports__